/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  ClaimTradingChallengePrizeOptions,
  ClaimTradingChallengePrizeStatus200,
  ClaimTradingChallengePrizeStatus403,
  ClaimTradingChallengePrizeStatus409,
  ClaimTradingChallengePrizeStatus410,
  ClaimTradingChallengePrizeStatus500,
  ClaimTradingChallengePrizeStatus504,
} from '../types/ClaimTradingChallengePrize'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { claimTradingChallengePrize } from '../clients/claimTradingChallengePrize'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const claimTradingChallengePrizeMutationKey = () =>
  [{ url: '/v1/trading_challenges/:trading_challenge_id/claim' }] as const

export function claimTradingChallengePrizeMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = claimTradingChallengePrizeMutationKey()
  return mutationOptions<
    ClaimTradingChallengePrizeStatus200,
    ResponseErrorConfig<
      | ClaimTradingChallengePrizeStatus403
      | ClaimTradingChallengePrizeStatus409
      | ClaimTradingChallengePrizeStatus410
      | ClaimTradingChallengePrizeStatus500
      | ClaimTradingChallengePrizeStatus504
    >,
    ClaimTradingChallengePrizeOptions,
    TContext
  >({
    mutationKey,
    mutationFn: async ({ path }) => {
      return claimTradingChallengePrize({ ...config, path, throwOnError: true }).unwrap()
    },
  })
}

/**
 * @description Claim an eligible trading challenge prize. TOURNAMENT requires completed KYC, credits the crown prize, reactivates the account, and marks the result PRIZE_CLAIMED. CASH requires completed KYC, winds down the account, sweeps remaining challenge credit, awards CASH_CROWN, and marks the result PRIZE_CLAIMED; the account stays deactivated with a zero balance. QR_PROMO accepts an eligible reward request before KYC, winds down the account, fixes the capped reward, queues a KYC email, and records REWARD_PENDING_KYC without paying the reward or reactivating the account.
 * @summary Claim challenge prize
 * {@link /v1/trading_challenges/:trading_challenge_id/claim}
 */
export function useClaimTradingChallengePrize<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ClaimTradingChallengePrizeStatus200,
      ResponseErrorConfig<
        | ClaimTradingChallengePrizeStatus403
        | ClaimTradingChallengePrizeStatus409
        | ClaimTradingChallengePrizeStatus410
        | ClaimTradingChallengePrizeStatus500
        | ClaimTradingChallengePrizeStatus504
      >,
      ClaimTradingChallengePrizeOptions,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? claimTradingChallengePrizeMutationKey()

  const baseOptions = claimTradingChallengePrizeMutationOptions(config) as UseMutationOptions<
    ClaimTradingChallengePrizeStatus200,
    ResponseErrorConfig<
      | ClaimTradingChallengePrizeStatus403
      | ClaimTradingChallengePrizeStatus409
      | ClaimTradingChallengePrizeStatus410
      | ClaimTradingChallengePrizeStatus500
      | ClaimTradingChallengePrizeStatus504
    >,
    ClaimTradingChallengePrizeOptions,
    TContext
  >

  return useMutation<
    ClaimTradingChallengePrizeStatus200,
    ResponseErrorConfig<
      | ClaimTradingChallengePrizeStatus403
      | ClaimTradingChallengePrizeStatus409
      | ClaimTradingChallengePrizeStatus410
      | ClaimTradingChallengePrizeStatus500
      | ClaimTradingChallengePrizeStatus504
    >,
    ClaimTradingChallengePrizeOptions,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    ClaimTradingChallengePrizeStatus200,
    ResponseErrorConfig<
      | ClaimTradingChallengePrizeStatus403
      | ClaimTradingChallengePrizeStatus409
      | ClaimTradingChallengePrizeStatus410
      | ClaimTradingChallengePrizeStatus500
      | ClaimTradingChallengePrizeStatus504
    >,
    ClaimTradingChallengePrizeOptions,
    TContext
  >
}
